export const FETCH_MAIN_CONTACTS = "FETCH_MAIN_CONTACTS"
export const FETCH_ALL_CONTACTS = "FETCH_ALL_CONTACTS"
export const CREATE_CONTACT = "CREATE_CONTACT"
export const CREATE_MAIN_CONTACT = "CREATE_MAIN_CONTACT"
export const UPDATE_CONTACT = "UPDATE_CONTACT"
export const DELETE_CONTACT = "DELETE_CONTACT"